import React from "react";
import { isNotNullOrEmpty } from "../lib/utilities";
import { useEntityById } from "../lib/hooks";
import TrailerSlider from "./trailerSlider";
import TrailerViewer from "./trailerViewer";
import BookView from "./bookView";
import * as api from "../lib/api";

const enrichSeries = (series) => {
  const seriesBooks = api.getBookItemsBySeriesId(series.id);
  return { ...series, items: [...api.sortBySeriesOrder(seriesBooks)] };
};

const SeriesView = ({ id }) => {
  const series = useEntityById(id, api.getSeriesById, enrichSeries);

  if (!series) return null;

  const getTrailerContent = (series) => {
    const trailers = api.getTrailers(series.items);

    if (isNotNullOrEmpty(trailers) || isNotNullOrEmpty(series.trailerUrl)) {
      const caption = `Watch the Trailer${trailers.length > 1 ? "s" : ""}`;
      return (
        <div>
          <h5 style={{ marginTop: 30 }}>{caption}</h5>
          {trailers.length > 1 ? (
            <TrailerSlider items={trailers} />
          ) : (
            <TrailerViewer itemId={series.id} videoId={series.trailerUrl} />
          )}
        </div>
      );
    }

    return undefined;
  };

  return (
    <div className="section contents">
      <div className="content">
        <div className="row">
          <div className="col">
            <h2 className="book-view-title">{series.title}</h2>

            {isNotNullOrEmpty(series.items) &&
              series.items.map((item, index) => {
                return (
                  <React.Fragment key={item.id}>
                    <BookView id={item.id} extraContent={false} />
                    {index < series.items.length - 1 && <hr />}
                  </React.Fragment>
                );
              })}
            {getTrailerContent(series)}
            {isNotNullOrEmpty(series.keywords) && (
              <p>
                Keywords: <em>{series.keywords.join(", ")}</em>
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SeriesView;
